// extracted by mini-css-extract-plugin
module.exports = {"addButton":"index_addButton_2e2OK","table_title":"index_table_title_VLe62"};